import React from "react";
import { ResponsiveDeviceType } from "../../../widget/layouts/ScreenMedia";
import Scaffold from "../../../widget/layouts/Scaffold";
import { MainBodyContainer } from "../../../widget/common/ui/MainContainer";
import AppTranslation from "../../../service/app_translation/AppTranslation";
import DeactivateAccountContent from "./DeactivateAccountContent";
import DeactivateAccountButtons from "./widget/DeactivateAccountButtons";

const DeactivateAccountScreen = () => {
  const type: number = ResponsiveDeviceType();

  return (
    <Scaffold
      appBarTitle={AppTranslation.text("deactivate_account")}
      bottomNavigationButton={<DeactivateAccountButtons />}
    >
      <MainBodyContainer>
        <DeactivateAccountContent type={type} />
      </MainBodyContainer>
    </Scaffold>
  );
};

export default DeactivateAccountScreen;
export const routeName: string = "/settings/deactivate-account";
